module.exports = __webpack_public_path__ + "media/promo/panasonic/images/buy-5-4d78aa1624be3c222ef9186499241353.png";